module.exports = __webpack_public_path__ + "img/Association_VPA_4.b84736ae.jpg";